const zh_cn = {
  account: "邮箱",
  code: "验证码",
  username: "名称",
  school: "学校名称",
  password: "密码",
  repeatPassword: "重复密码",
  sex: "性别",
  confirm: "确定",
  title: "注册账号",
  man: "男性",
  woman: "女性",
  avatar: "头像",
  change_info: "编辑",
  change_avatar: "更换头像",
  send: "发送",
  sendAgain: "再次发送",
  typeCode: "输入6位验证码",
  typeMail: "邮箱地址",
  typePassword: "登录密码",
  typePasswordAgain: "验证密码",
  typeName: "输入名称",
  imageCode: "图片验证码",
  typeImageCode: "输入图片验证码",
  sendCode: "发送验证码",
  institution: "学校名称",
  class: "班级",
  newAccount: "账号",
  optional: "可选",
  signIn: "登录",
  usePromo: "验证中",
  internal: "是否内部账号",
  yes: "是",
  no: "否",
  logout: "登出",
  verificationCode: "通过电子邮件发送验证码到你的邮箱",
  verificationCodeSuccess: "验证码已发送到您的电子邮件",
  success: "注册成功！",
  login: "进入系统",
  goSubscribe: "去订阅",
  inSubscription: "订阅中",
  uploadingProfilePicture: "正在上传头像",
  userName: "账号",
  nickName: "名称",
  nickNameEn: "英文名称",
  remark: "备注",
  email: "邮箱"
};

const zh_hant = {
  account: "電郵",
  code: "電郵驗證碼",
  username: "名稱",
  school: "任教學校名稱",
  password: "密碼",
  repeatPassword: "重複密碼",
  sex: "性别",
  confirm: "確定",
  title: "註冊賬號",
  man: "男性",
  woman: "女性",
  avatar: "頭像",
  change_info: "修改",
  change_avatar: "更換頭像",
  send: "發送",
  sendAgain: "再次發送",
  typeCode: "輸入6位驗證碼",
  typeMail: "電郵地址",
  typePassword: "登錄密碼",
  typePasswordAgain: "驗證密碼",
  typeName: "輸入稱呼",
  imageCode: "圖片驗證碼",
  typeImageCode: "輸入圖片驗證碼",
  sendCode: "發送電郵驗證碼",
  institution: "任教學校名稱",
  class: "班級",
  newAccount: "賬號",
  optional: "可選",
  signIn: "登錄中",
  usePromo: "校驗兌換碼",
  internal: "是否內部賬號",
  yes: "是",
  no: "否",
  logout: "登出",
  verificationCode: "通過電子郵件發送驗證碼到你的郵箱",
  verificationCodeSuccess: "驗證碼已發送到您的電子郵件",
  success: "注冊成功！",
  login: "進入系統",
  goSubscribe: "去訂閱",
  inSubscription: "訂閱中",
  uploadingProfilePicture: "正在上傳頭像",
  userName: "賬號",
  nickName: "名稱",
  nickNameEn: "英文名稱",
  remark: "備註",
  email: "電郵"
};

const en = {
  account: "Email Address",
  code: "Verification Code",
  username: "Name",
  school: "School Name",
  password: "Password",
  repeatPassword: "Repeat password",
  sex: "Gender",
  confirm: "Confirm",
  title: "Sign Up",
  man: "Male",
  woman: "Female",
  avatar: "Avatar",
  change_info: "Edit",
  change_avatar: "Change avatar",
  send: "Send",
  sendAgain: "Send again",
  typeCode: "Enter 6-digit code",
  typeMail: "Email Address",
  typePassword: "Login password",
  typePasswordAgain: "Verify password",
  typeName: "Enter name",
  imageCode: "Code",
  typeImageCode: "Enter code from image",
  sendCode: "Send verify-code",
  institution: "School",
  class: "Class",
  newAccount: "Account",
  optional: "Optional",
  signIn: "Sign in",
  usePromo: "Verifying",
  internal: "Internal account",
  yes: "Yes",
  no: "No",
  logout: "Sign out",
  verificationCode: "Send the verification code to your email",
  verificationCodeSuccess: "Verification Code sent to your email",
  success: "Successfully registered!",
  login: "Enter the system",
  goSubscribe: "Go subscribe",
  inSubscription: "Subscribing",
  uploadingProfilePicture: "Uploading profile picture",
  userName: "Account",
  nickName: "Name",
  nickNameEn: "English Name",
  remark: "Remark",
  email: "Email"
};

const es = {
  account: "Dirección de correo electrónico",
  code: "Código de verificación",
  username: "Nombre",
  school: "Nombre de la escuela",
  password: "Contraseña",
  repeatPassword: "Repetir contraseña",
  sex: "Género",
  confirm: "Confirmar",
  title: "Registrarse",
  man: "Masculino",
  woman: "Femenino",
  avatar: "Avatar",
  change_info: "Editar",
  change_avatar: "Cambiar avatar",
  send: "Enviar",
  sendAgain: "Enviar de nuevo",
  typeCode: "Ingresar código de 6 dígitos",
  typeMail: "Dirección de correo electrónico",
  typePassword: "Contraseña de inicio de sesión",
  typePasswordAgain: "Verificar contraseña",
  typeName: "Ingresar nombre",
  imageCode: "Código",
  typeImageCode: "Ingresar código de la imagen",
  sendCode: "Enviar",
  institution: "Escuela",
  class: "Clase",
  newAccount: "Cuenta",
  optional: "Opcional",
  signIn: "Iniciar sesión",
  usePromo: "Verificando",
  internal: "Cuenta interna",
  yes: "Sí",
  no: "No",
  logout: "Cerrar sesión",
  verificationCode: "Enviar el código de verificación a su correo electrónico",
  verificationCodeSuccess: "El Código de verificación ha sido enviado a su correo electrónico",
  success: "¡Registrado con éxito!",
  login: "Ingrese al sistema",
  goSubscribe: "Ir a suscribirse",
  inSubscription: "En suscripción",
  uploadingProfilePicture: "Cargando imagen de perfil",
  userName: "Cuenta",
  nickName: "Nombre",
  nickNameEn: "Nombre inglés",
  remark: "Nota",
  email: "Correo electrónico"
};

export default {
  en,
  zh_hant,
  es,
  zh_cn
};
